import { HttpRequestPost } from "./../../service/index";
import QueuedOrders from "../symbols/queuedOrders";
import { roleName } from "../../utils/roles";
import { IOrderFilter } from "./pendingOrders";

type GetOrdersRequestModel = {
  Filter: IOrderFilter;
  OrderBy: string;
  Query: string;
  Page: number;
  Size: number;
};
const queuedOrdersAction = () => ({
  type: QueuedOrders.QUEUED_ORDERS,
});
const queuedOrdersSuccessAction = (data: any) => ({
  type: QueuedOrders.QUEUED_ORDERS_SUCCESS,
  payload: data,
});
const queuedOrdersFailureAction = (data: any) => ({
  type: QueuedOrders.QUEUED_ORDERS_FAILURE,
  payload: data,
});
const clearQueuedOrdersAction = () => ({
  type: QueuedOrders.CLEAR_QUEUED_ORDERS,
});

export function getQueuedOrders(
  data?: GetOrdersRequestModel,
  callback?: (resp?) => void
) {
  let url = `/${roleName().toLowerCase()}/deliveries/queued`;
  return (dispatch: any) => {
    dispatch(queuedOrdersAction());
    HttpRequestPost(
      url,
      dispatch,
      queuedOrdersSuccessAction,
      queuedOrdersFailureAction,
      true,
      data || {
        Query: "",
        Filter: { Status: [] },
        OrderBy: "desc",
      },
      callback
    );
  };
}

export function clearQueuedOrders() {
  return (dispatch: any) => {
    dispatch(clearQueuedOrdersAction());
  };
}
